import {Provider} from '@/models/Provider'
import React from 'react'

export default function ProviderCardSimple({provider}: {
    provider: {
        name: Provider['name'],
        profileImageURL: Provider['profileImageURL'],
        subtitle?: Provider['subtitle']
    }
}) {
    return (
        <div
            className={'border border-brand-border-gray rounded-brand-rounded py-[18px] px-[16px] gap-[10px] flex flex-row content-center bg-white'}>
            <img
                width={'60px'}
                height={'60px'}
                data-testid={'avatar'}
                className={'rounded-full w-[60px] h-[60px]'}
                alt={'Avatar'}
                src={provider.profileImageURL}
            />
            <div className={'flex flex-col flex-1 gap-[2px] justify-center'}>
                <h3 className={'font-semibold antialiased'}>
                    {provider.name}
                </h3>
                <h3 className={'antialiased'}>
                    {provider.subtitle}
                </h3>
            </div>
        </div>
    )
}
